import React, { useState, useEffect } from 'react';

const calculateWindowHeight = (props) => {
  const { includeFooter = true } = props;
  const windowHeight = props.window.innerHeight;
  return includeFooter ? windowHeight : windowHeight - PageFooter.getHeight();
}

export function useWindowDimension(props) {
  const [dimension, setDimension] = useState({
    width: window.innerWidth,
    height: calculateWindowHeight({...props, window}),
  });
  useEffect(() => {
    const debouncedResizeHandler = CommonUtils.chrDebounce(() => {
      setDimension({ width: window.innerWidth, height: calculateWindowHeight({...props, window})});
    }, 100); // 100ms
    window.addEventListener('resize', debouncedResizeHandler);
    return () => window.removeEventListener('resize', debouncedResizeHandler);
  }, []);
  return dimension;
}